package com.eladfinish.bible.contest.extensions

import dev.icerock.moko.resources.desc.Raw
import dev.icerock.moko.resources.desc.StringDesc

@Suppress("FunctionName")
fun StringDesc.Companion.Empty() = StringDesc.Raw("")

fun StringDesc?.orEmpty(): StringDesc {
    return this ?: StringDesc.Empty()
}
